module.exports = __webpack_public_path__ + "static/media/PPA-Black.482426c6.svg";